import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error) => {
      const urlLower = req.url.toLowerCase();
      const isBlobRequest = urlLower.includes('blob.core.windows.net') || urlLower.includes('?sv=') || urlLower.includes('&sig=');
      // 401 means the session is gone. 403 only means "not allowed here" (e.g. another branch) and must not log the user out.
      if (error.status === 401 && !isBlobRequest) {
        const currentUrl = router.url || '';
        if (!currentUrl.includes('/login') && !currentUrl.includes('/reset-password') && currentUrl !== '/') {
          authService.logOut(currentUrl);
        }
      }
      return throwError(() => error);
    })
  );
};